<template>
  <WebccTooltip @click.stop>
    <WebccIcon name="site/info-new" class="w-4 h-4 text-txt-weak" />

    <template #content>
      <article v-html="legalInfo.content"></article>
    </template>
  </WebccTooltip>
</template>

<script setup lang="ts">
const legalInfo = usePriceLegalInfoTooltip()
</script>
